import axios from 'axios';
// config
import { HOST_API, } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
});

// Request interceptor - restore Authorization header on every request
axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = window.localStorage.getItem('accessToken');
    if (accessToken && accessToken !== 'undefined' && accessToken !== 'null') {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,

  (error) => {
    // Handle 401 Unauthorized - Token expired or invalid
    if (error.response?.status === 401) {
      console.warn('[Axios] 401 Unauthorized - Clearing session');
      localStorage.removeItem('accessToken');
      localStorage.clear();
      
      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/auth/login')) {
        window.location.href = '/auth/login';
      }
    }
    
    const message = (error.response && error.response.data && (error.response.data.message || error.response.data.error || JSON.stringify(error.response.data))) || error.message || 'Something went wrong';
    return Promise.reject({ message });
  }
);


export default axiosInstance;
